export class DCCommunityPortalSRNotes {
    Note: string = "";
    "Note Type": string = "";
}

export class ListOfDCCommunityPortalSRNotes {
    "DC Community Portal SR Notes": DCCommunityPortalSRNotes[] = [];
}

export class DCCommunityPortalSR {
    "SR Number": string = "";
    CSN: string = "";
    "SR Type": string = "";
    "Sub Type": string = "";
    "DC Payment Method": string = "";
    "DC Channel": string = "Online";
    "DC Account Holder": string = "";
    "DC Holder Bank Name": string = "";
    "DC IBAN No": string = "";
    "DC Carnet Number": string = "";
    "DC Bank Loc": string = "";
    "DC Swift Code": string = "";
    "DC ATA Reason": string = "";
    "ListOfDC Community Portal SR Notes": ListOfDCCommunityPortalSRNotes = new ListOfDCCommunityPortalSRNotes();
    "DC ATA Consent": string = "Y";
    "DC ATA Pledged Letter Consent": string = "Y";
    "DC Bank Detail Consent": string = "Y";
}

export class ListOfDCCommunityPortalSRUpsertIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCIncomingHierarchy {
    MessageId: string = "";
    IntObjectName: string = "DC Community Portal SR Upsert IO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIO = new ListOfDCCommunityPortalSRUpsertIO();
}

export class ATARefundBody {
    ProcessName: string = "DC Community Portal SR Process Wrapper WF";
    DCMethod: string = "SUBMIT";
    DCLoginName: string = "";
    DCLanguage: string = "ENU";
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class ATARefundRequest {
    body: ATARefundBody = new ATARefundBody();
}
